import { Grid } from "@mui/material";
import { useAtom } from "jotai/index";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import RoomsManagementModule from "@/module/rooms-management-module/rooms-management-module";
import { headerTitle } from "@/store/store";

const RoomsManagementPage = () => {
  const { t } = useTranslation();

  const [, setHeaderTitle] = useAtom(headerTitle);
  useEffect(() => {
    setHeaderTitle(t("roomManagement"));
  }, [setHeaderTitle, t]);

  return (
    <Grid
      container
      direction="column"
      flexWrap="nowrap"
      sx={{ height: "100%", minHeight: 0, overflow: "hidden" }}
    >
      <Grid
        item
        sx={{
          display: "flex",
          flex: 1,
          flexDirection: "column",
          minHeight: 0,
          width: "100%",
        }}
      >
        <RoomsManagementModule />
      </Grid>
    </Grid>
  );
};

export default RoomsManagementPage;
